<template>
  <div>
    <v-loading :isLoading="loading"></v-loading>
    <div class="summary" v-if="!loading">
      <div class="panel-content-inner">
        <div class="row">
          <div class="col-2">
            <div class="form-group form-material">
              <label class="control-label title-text" for="web-site-language">{{ $t('input.lang') }}</label>
              <select id="web-site-language" class="form-control" v-model="activeLang" @change="changeLang()">
                <option v-for="language in languages" :value="language.code">{{ $t(`account.settings.message_templates_section.${language.name}`) }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div id="summary" @input="changeUserWebContent($event, 'description')" @keyup="changeUserWebContent($event, 'description')">
              <p class="title-text">{{ $t('rentals.website.summary') }}</p>
              <redactor
                :webSite="true"
                :contract="summary"
                :rentalId="rental.id"
                v-model="summary"
                className="summary-redactor"
                @changeSummaryByRedactor="changeSummaryByRedactor"
                @showErrorMessage="showErrorMessage"
              ></redactor>
            </div>
          </div>
          <div class="col-6">
            <div id="things-to-note" @input="changeUserWebContent($event, 'note')" @keyup="changeUserWebContent($event, 'note')">
              <p class="title-text">{{ $t('rentals.website.things_to_note') }}</p>
              <redactor
                :webSite="true"
                :contract="thingsToNote"
                :rentalId="rental.id"
                v-model="thingsToNote"
                className="things-to-note-redactor"
                @changeNoteByRedactor="changeNoteByRedactor"
                @showErrorMessage="showErrorMessage"
              ></redactor>
            </div>
          </div>
          <div class="col-6 mt-15">
            <div id="cgv" @input="changeUserWebContent($event, 'cgv')" @keyup="changeUserWebContent($event, 'cgv')">
              <p class="title-text">{{ $t('rentals.website.cgv') }}<span>
                <i
                  data-toggle="popover"
                  data-trigger="manual"
                  :data-content="$t('rentals.website.cgv_infos')"
                  class="fa fa-info-circle fa-specified rental-detail-popover"
                ></i>
              </span></p>
              <redactor
                :webSite="true"
                :contract="cgv"
                :rentalId="rental.id"
                v-model="cgv"
                className="cgv-redactor"
                @changeCgvByRedactor="changeCgvByRedactor"
                @showErrorMessage="showErrorMessage"
              ></redactor>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="the-space" id="theSpace">
              <p class="title-text">{{ $t('rentals.website.the_space') }}</p>
              <div class="bg-white white-section">
                <ImageUploader
                  :addImage="addImage"
                  :handleLabelChange="handleLabelChange"
                  type="theSpace"
                  :value="theSpace.label"
                  :selectImage="selectImage"
                  :fileSelected="theSpaceSelectedImage"
                  :rotateImg="rotateImg"
                  :lang="account.lang"
                  :disableAddImage = disableAddImagetheSpace
                />
                <p>{{ $t('rentals.website.image_format') }}</p>
                <ImagesBox
                  type="theSpace"
                  @deleteUploadedImage="deleteUploadedImage"
                  v-on:updateImagesOrder="updateImagesOrder"
                  :images="theSpaceImages"
                  :imageDeleted="imageDeleted"
                />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="the-space" id="amenity">
              <p class="title-text">{{ $t("rentals.website.amenities") }}</p>
              <div class="bg-white white-section">
                <ImageUploader
                  :handleLabelChange="handleLabelChange"
                  :addImage="addImage"
                  :rotateImg="rotateImg"
                  :fileSelected="amenitySelectedImage"
                  type="amenity"
                  :value="amenity.label"
                  :selectImage="selectImage"
                  :lang="account.lang"
                  :disableAddImage = disableAddImageamenity
                />
                <p>{{ $t('rentals.website.image_format') }}</p>

                <ImagesBox
                  type="amenity"
                  @deleteUploadedImage="deleteUploadedImage"
                  v-on:updateImagesOrder="updateImagesOrder"
                  :images="amenityImages"
                  :imageDeleted="imageDeleted"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-25">
          <div class="col-6">
            <div class="the-space" id="slider">
              <p class="title-text">{{ $t('rentals.website.slider_images') }}</p>
              <div class="bg-white white-section">
                <ImageUploader
                  :handleLabelChange="handleLabelChange"
                  :addImage="addImage"
                   type="slider"
                  :value="slider.label"
                  :selectImage="selectImage"
                  :rotateImg="rotateImg"
                  :fileSelected="sliderSelectedImage"
                  :lang="account.lang"
                  :disableAddImage = disableAddImageslider
                />
                <ImagesBox
                  type="slider"
                  @deleteUploadedImage="deleteUploadedImage"
                  v-on:updateImagesOrder="updateImagesOrder"
                  :images="sliderImages"
                  :imageDeleted="imageDeleted"
                />
              </div>
            </div>
            <div class="the-space">
              <label class="control-label title-text">{{ $t('rentals.website.custom_error_messages') }}</label>
              <div class="bg-white white-section">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group form-material">
                      <label for="message-title" class="control-label">
                        {{ $t('rentals.website.error_title') }}
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="message-title"
                        v-model="customMessages.error_title"
                        @input="changeUserWebContent($event, 'error_title')"
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group form-material">
                      <label for="message-desc" class="control-label">
                        {{ $t('rentals.website.error_desc') }}
                      </label>
                      <textarea
                        id="message-desc"
                        class="form-control"
                        cols="30"
                        rows="10"
                        v-model="customMessages.error_description"
                        @input="changeUserWebContent($event, 'error_description')"
                      >
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="the-space">
              <label class="control-label title-text">{{ $t('rentals.website.gps_coordinators') }}</label>
              <div class="map-section bg-white white-section">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group form-material">
                      <label for="map-latitude" class="control-label">
                        Latitude
                      </label>
                      <span>
                            <i
                              data-toggle="popover"
                              data-trigger="manual"
                              :data-content="$t('rentals.website.coordinates_info')"
                              class="fa fa-info-circle fa-specified rental-detail-popover"
                            ></i>
                          </span>
                      <input type="text" class="form-control" id="map-latitude" v-model="map.latitude">
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group form-material">
                      <label for="map-longitude" class="control-label">
                        Longitude
                      </label>
                      <span>
                            <i
                              data-toggle="popover"
                              data-trigger="manual"
                              :data-content="$t('rentals.website.coordinates_info')"
                              class="fa fa-info-circle fa-specified rental-detail-popover"
                            ></i>
                          </span>
                      <input type="text" class="form-control" id="map-longitude" v-model="map.longitude">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="the-space">
              <label class="control-label title-text">{{ $t('rentals.website.display') }}</label>
              <div class="bg-white white-section">
                <div class="row">
                  <div class="checkbox-custom checkbox-inline checkbox-primary ">
                    <input type="checkbox" id="display" :checked="rentalDisplayField" @change="updateRentalDisplayField">
                    <label for="display">{{ $t('rentals.website.display_in_site') }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="the-space">
              <label class="control-label title-text">{{ $t('rentals.website.reservation_mode_title') }}</label>
              <div class="bg-white white-section">
                <div class="row">
                  <div class="checkbox-custom checkbox-inline checkbox-primary ">
                    <input type="checkbox" id="display" :checked="mailRequestEnabled" @change="updateRentalMailRequestEnabled">
                    <label for="display">{{ $t('rentals.website.reservation_mode_checkbox') }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="the-space">
              <label class="control-label title-text">{{ $t('rentals.website.first_payment') }}</label>
              <div class="bg-white white-section">
                <div class="row">
                  <div class="col-6">
                    <div class="checkbox-custom checkbox-inline checkbox-primary ">
                      <input type="checkbox" id="first-payment" :checked="firstPayment" @change="updateFirstPayment">
                      <label for="display">{{ $t('rentals.website.enable_first_payment') }}</label>
                    </div>
                  </div>
                  <div class="col-6" v-show="firstPayment">
                    <div class="form-group form-material">
                      <label for="percent">{{ $t('input.percent') }} %</label>
                      <input type="text" class="form-control" id="percent" v-model="percent">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileService from '../../../services/file';
import websiteService from '../../../services/website';
import ImagesBox from './ImagesBox';
import ImageUploader from './ImageUploader';
import mixin from '../../../mixins/mixin';
import _ from 'lodash';

export default {
  name: 'website',
  data() {
    return {
      summary: '',
      pixelHead: '',
      pixelBody: '',
      thingsToNote: '',
      cgv: '',
      map: {
        latitude: '',
        longitude: '',
      },
      theSpace: {
        label: '',
        file: {},
      },
      amenity: {
        label: '',
        file: {},
      },
      slider: {
        file: {},
      },
      theSpaceImages: [],
      amenityImages: [],
      sliderImages: [],
      loading: false,
      imageDeleted: false,
      rentalDisplayField: true,
      mailRequestEnabled: false,
      firstPayment: false,
      percent: 30,
      sliderRotation: 0,
      theSpaceRotation: 0,
      amenityRotation: 0,
      customMessages: {
        error_title: '',
        error_description: '',
      },
      sliderSelectedImage: false,
      theSpaceSelectedImage: false,
      amenitySelectedImage: false,
      activeLang: 'fr',
      languages: {
        french: {
          code: 'fr',
          name: 'french',
        },
        english: {
          code: 'en',
          name: 'english',
        },
        portuguese: {
          code: 'pt',
          name: 'portugal',
        },
        spanish: {
          code: 'es',
          name: 'spanish',
        },
        italian: {
          code: 'it',
          name: 'italian',
        },
      },
      user_web: {
        description_en: '',
        description_fr: '',
        description_pt: '',
        description_es: '',
        description_it: '',
        notes_en: '',
        notes_fr: '',
        notes_pt: '',
        notes_es: '',
        notes_it: '',
        cgv_en: '',
        cgv_fr: '',
        cgv_es: '',
        cgv_pt: '',
        cgv_it: '',
        error_title_fr: '',
        error_title_en: '',
        error_title_pt: '',
        error_title_es: '',
        error_title_it: '',
        error_description_fr: '',
        error_description_en: '',
        error_description_pt: '',
        error_description_es: '',
        error_description_it: '',
      },
      disableAddImagetheSpace: false,
      disableAddImageamenity: false,
      disableAddImageslider: false,
    };
  },
  props: [
    'rental',
    'webSiteDefaultContent',
  ],
  mixins: [mixin],
  components: {
    ImageUploader,
    ImagesBox,
    Redactor: require('components/redactor/redactor.vue'),
    VLoading: require('components/loading/loading.vue'),
  },
  mounted() {
    window.onload = () => {
      $('#amenity .dropify-clear').click(() => {
        this.amenityRotation = 0;
      });
      $('#slider .dropify-clear').click(() => {
        this.sliderRotation = 0;
      });
      $('#theSpace .dropify-clear').click(() => {
        this.theSpaceRotation = 0;
      });
    };
  },
  watch: {
    rental(newRental) {
      if (newRental && newRental.user_web) {
        const { user_web } = newRental;
        this.map.latitude = user_web.lat;
        this.map.longitude = user_web.long;
        this.user_web = { ...newRental.user_web };
        $('#summary #redactor-uuid-0').html(this.user_web[`description_${this.activeLang}`]);
        $('#things-to-note #redactor-uuid-0').html(this.user_web[`note_${this.activeLang}`]);
        $('#cgv #redactor-uuid-0').html(this.user_web[`cgv_${this.activeLang}`]);
        this.theSpaceImages = user_web.files;
        this.amenityImages = user_web.webAmenities;
        this.sliderImages = user_web.slider_images;
        this.rentalDisplayField = user_web.display;
        this.mailRequestEnabled = user_web.mail_request_enabled;
        this.firstPayment = user_web.first_payment;
        this.percent = user_web.percent;
        this.customMessages = {
          error_title: user_web[`error_title_${this.activeLang}`],
          error_description: user_web[`error_description_${this.activeLang}`],
        };
      }
    },
    webSiteDefaultContent(val) {
      if (Object.keys(val).length !== 0 && !this.rental.user_web) {
        this.user_web = val;
        $('#summary #redactor-uuid-0').html(this.user_web[`description_${this.activeLang}`]);
        $('#things-to-note #redactor-uuid-0').html(this.user_web[`note_${this.activeLang}`]);
        $('#cgv #redactor-uuid-0').html(this.user_web[`cgv_${this.activeLang}`]);
        this.amenityImages = val.webAmenities;
        this.customMessages.error_title = val[`error_title_${this.activeLang}`];
        this.customMessages.error_description = val[`error_description_${this.activeLang}`];
      }
    },
  },
  methods: {
    selectImage(event, type) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this[`${type}Rotation`] = 0;
      this[type].file = [...files];
      const name = `${type}SelectedImage`;
      this[name] = true;
    },
    rotateImg(name, type) {
      $(`#${type} .dropify-render img`).css({ top: 0 });
      if (name === 'left') {
        this[`${type}Rotation`] = (this[`${type}Rotation`] - 90) % 360;
      } else {
        this[`${type}Rotation`] = (this[`${type}Rotation`] + 90) % 360;
      }
      $(`#${type} .dropify-render img`).css({ transform: `rotate(${this[`${type}Rotation`]}deg)` });
    },
    addImage(type) {
      if (!this.validateImg(type)) {
        return;
      }
      this[`disableAddImage${type}`] = true;
      const name = `${type}SelectedImage`;
      const formData = new FormData();
      const files = this[type].file;
      files.forEach(file => formData.append('image[]', file));

      formData.append('folder', 'forms');
      formData.append('rotation', this[`${type}Rotation`]);

      fileService.uploadImageMulti(this, formData).then((response) => {
        if (response && response.status === 200) {
          this[`${type}Rotation`] = 0;
          const uploadedFiles = response.data.files;
          const images = `${type}Images`;
          uploadedFiles.forEach(f => this[images].push({ label: this[type].label, url: f.path, image: f.name }));

          this[type].file = {};
          $(`#${type} .add-image`).find('.dropify-wrapper').find('.dropify-clear').click();
          this[type].label = '';
          this[name] = false;
          this[`disableAddImage${type}`] = false;
        }
      }).catch((error) => {
        this[name] = false;
        this[`${type}Rotation`] = 0;
        this[`disableAddImage${type}`] = false;
        toastr.error(this.$t('allowed_formats'));
      });
    },
    saveData() {
      const types = ['amenity', 'slider', 'theSpace'];
      let oldImages = [];
      types.map((type) => {
        const images = _.cloneDeep(this[`${type}Images`]);
        if (images.length > 0) {
          if (images.every(i => i.order === null)) {
            oldImages = images;
          } else {
            oldImages = images.filter(img => Object.keys(img).includes('order') && img.order !== null);
          }
          let max = Math.max(...oldImages.map(i => i.order));
          images.map((i) => {
            if (!Object.keys(i).includes('order') || i.order === null) {
              i.order = max + 1;
              max = i.order;
            }
          });
          this[`${type}Images`] = images;
        }
      });
      let data = {
        map: this.map,
        theSpaceImage: this.theSpaceImages,
        amenityImages: this.amenityImages,
        sliderImages: this.sliderImages,
        rentalId: this.rental.id,
        rentalDisplayField: this.rentalDisplayField,
        mailRequestEnabled: this.mailRequestEnabled,
        firstPayment: this.firstPayment,
        percent: this.firstPayment ? this.percent : 30,
      };
      data = { ...this.user_web, ...data };
      websiteService.save(this, data);
    },
    async deleteUploadedImage(image, index, type) {
      this.imageDeleted = false;
      image.type = type;
      image.rentalId = this.rental.id;
      await websiteService.deleteImage(this, image, index);
      this.imageDeleted = true;
    },
    validateImg(section) {
      if (section !== 'slider' && this[section].label === '') {
        toastr.error(this.$t('rentals.website.label_validation_msg'));
        return false;
      }
      if (!Object.values(this[section].file).length || (this[section].file.some(f => !!f.name === false))) {
        toastr.error(this.$t('rentals.website.file_validation_msg'));
        return false;
      }
      return true;
    },

    updateImagesOrder(type, images) {
      const imageType = `${type}Images`;
      this[imageType] = images;
    },
    handleLabelChange(field, value) {
      this[field].label = value;
    },
    updateRentalDisplayField() {
      this.rentalDisplayField = !this.rentalDisplayField;
    },
    updateRentalMailRequestEnabled() {
      this.mailRequestEnabled = !this.mailRequestEnabled;
    },
    updateFirstPayment() {
      this.firstPayment = !this.firstPayment;
    },
    changeLang() {
      $('#summary #redactor-uuid-0').html(this.user_web[`description_${this.activeLang}`]);
      $('#things-to-note #redactor-uuid-0').html(this.user_web[`note_${this.activeLang}`]);
      $('#cgv #redactor-uuid-0').html(this.user_web[`cgv_${this.activeLang}`]);
      this.customMessages.error_title = this.user_web[`error_title_${this.activeLang}`];
      this.customMessages.error_description = this.user_web[`error_description_${this.activeLang}`];
      this.$forceUpdate();
    },
    changeUserWebContent(event, type = 'description') {
      let content = '';
      setTimeout(() => {
        if (type === 'description' || type === 'note' || type === 'cgv') {
          content = event.target.innerHTML;
        } else {
          content = this.customMessages[type];
        }
        this.user_web[`${type}_${this.activeLang}`] = content;
      }, 0);
    },
    changeNoteByRedactor() {
      let content = '';
      content = $('#things-to-note .redactor-box div').html()
      this.user_web[`note_${this.activeLang}`] = content;
    },
    changeSummaryByRedactor() {
      let content = '';
      content = $('#summary .redactor-box div').html()
      this.user_web[`description_${this.activeLang}`] = content;
    },
    changeCgvByRedactor() {
      let content = '';
      content = $('#cgv .redactor-box div').html()
      this.user_web[`cgv_${this.activeLang}`] = content;
    },
    showErrorMessage() {
      toastr.error(this.$t('valid_url'));
    },
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    },
  }
};
</script>




// WEBPACK FOOTER //
// website.vue?5351c27a